angular.module('aprima-bridge').factory('XamarinBridge',
    ['$timeout', '_', 'HostedBridgeService', 'WebViewManager', 'NgZoneService', function ($timeout, _, HostedBridgeService, WebViewManager, NgZoneService) {
        'use strict';

        var getBridge = function () {
            return HostedBridgeService;
        };

        // This zoneAwareObject always needs to be the last parameter to this function.
        function zoneAwareOn(event, $scope, fn, zoneAwareObject) {
            //handles events received from the getBridge() and removes the event when the scope is destroyed

            var handlerForScope = function (args) {

                function handler () {
                    fn(args);
                }

                if($scope && $scope.$evalAsync) {
                    $scope.$evalAsync(function() {
                        handler();
                    });
                }
                else {
                    handler();
                }
            };

            var zoneAwareHandlerFn = zoneAwareObject.wrapToRunInZoneIfNecessary(handlerForScope);

            var removeEventListener = function(){
                getBridge().removeEventListener(event, zoneAwareHandlerFn);

                //only allow this function to be called once
                removeEventListener = angular.noop;
            };

            if ($scope) {
                $scope.$on('$destroy', function () {
                    removeEventListener();
                });
            }

            getBridge().addEventListener(event, zoneAwareHandlerFn);

            return removeEventListener;
        }

        return {
            fireEvent: function fireEvent(eventName, data){
                getBridge().fireEvent(eventName, data);
            },

            on: function (event, $scope, fn) {
                return NgZoneService.contextRun(function (zoneAwareObject) {
                    return zoneAwareOn(event, $scope, fn, zoneAwareObject);
                }, true);
            },

            setupPage: function (nativeSettings) {
                WebViewManager.setupPage(nativeSettings);
            },
            setHeaderMode: function (mode) {
                getBridge().fireEvent('setHeaderMode', {
                    mode: mode
                });
            },

            createModalAlert: function (args) {
                getBridge().fireEvent('createModalAlert', args);
            },

            closeSearchHeader: function () {
                getBridge().fireEvent('closeSearchHeader', {});
            },
            pageFinished: function () {
                $timeout(function(){
                    getBridge().fireEvent('pagefinished', {});
                }, 0);
            },
            pickMedia: function (id, buttonText) {
                getBridge().fireEvent('pickMedia', {Id: id, SaveButtonText: buttonText});
            },
            updateBadges: function() {
                getBridge().fireEvent('updateBadges', {});
            },
            updatePageIndicator: function(itemCount, currentItem, useLastHeader) {
                getBridge().fireEvent('updatePageIndicator', { itemCount: itemCount, currentItem: currentItem, useLastHeader: useLastHeader});
            },           
            overriddenMessages: function(args) {                
                getBridge().fireEvent('overriddenMessages', {fileKey: args[1], logData: JSON.stringify([].slice.call(args, 2)) });
            },
            debugModeToggled: function(args){
                getBridge().fireEvent('debugModeToggled', {debugMessage: args[0],fileKey: args[1],  extraInfo: JSON.stringify([].slice.call(args,2))});
            },
            updateInactivityTimeout: function(userInactivityTimeout) {
                getBridge().fireEvent('updateInactivityTimeout', { timeout: userInactivityTimeout });
            },
            scanBarcode: function(id) {
                getBridge().fireEvent('scanBarcode', {Id: id});
            },
        };
    }]);
